module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"fillCompanyInfo":"Прежде чем разместить вакансию, необходимо заполнить информацию о компании","fill":"Заполнить"}}')
  delete Component.options._Ctor
}
